// extracted by mini-css-extract-plugin
export default {"TopBlock":"TopBlock_TopBlock__HeS4p"};